// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "pagination-rSVpj";
var _3 = "item-3A82_";
var _4 = "variant_default-3i2bv";
var _5 = "item_active-1SHOu";
var _6 = "lightBg-3oD2J";
var _7 = "onPhoto-nLySI";
var _8 = "bigCircles-3cZGB";
export { _1 as "__esModule", _2 as "pagination", _3 as "item", _4 as "variant_default", _5 as "item_active", _6 as "lightBg", _7 as "onPhoto", _8 as "bigCircles" }
export default { "__esModule": _1, "pagination": _2, "item": _3, "variant_default": _4, "item_active": _5, "lightBg": _6, "onPhoto": _7, "bigCircles": _8 }
